// @ts-nocheck
import React, { useState, useEffect } from "react";
import {
  Elements,
  useStripe,
  useElements,
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import style from "./Stripe.module.scss";
import PropTypes from "prop-types";
import { getImageUrl } from "../../../commons/assets_path";
import { useTranslation } from "react-i18next";
import { placeholder } from "../../templates/dynamic_tables/FilterForm/FilterForm.module.scss";

export const Stripe = ({ client, register, isUpdate, update, setIsUpdate, updateAmountPlan, setIsLoading }) => {
  const stripePromise = loadStripe(process.env.VITE_STRIPE_API_KEY);
  const [clientSecret, setClientSecret] = useState();
  const { t } = useTranslation();

  const getClientSecret = () => {
    axios.get(`/${client}/api_cards/client_secret`).then((res) => {
      setClientSecret(res.data.client_secret);
    });
  };

  useEffect(() => {
    getClientSecret();
  }, []);

  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret: clientSecret,
      }}
    >
      <CreditInput
        client={client}
        register={(token) => register(token)}
        isUpdate={isUpdate}
        update={(token) => update(token)}
        setIsUpdate={setIsUpdate}
        updateAmountPlan={updateAmountPlan}
        setIsLoading={setIsLoading}
      />
    </Elements>
  );
};

const CreditInput = ({ client, register, isUpdate, update, setIsUpdate, updateAmountPlan, setIsLoading }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [errMessage, setErrMessage] = useState("");
  const [isComplete, setIsComplete] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const { t } = useTranslation();

  const StripeFieldOptions = {
    style: {
      base: {
        iconColor: "#32cdc8",
      },
      complete: {
        iconColor: "#32cdc8",
      },
      invalid: {
        iconColor: "#ff4958",
        color: "#ff4958",
      },
    },
    hidePostalCode: true,
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setIsLoading(true);
    if (!isSubmit) {
      setIsSubmit(true);

      if (!stripe || !elements) {
        setIsSubmit(false);
        setIsLoading(false);
        return;
      }

      const cardNumberElement = elements.getElement(CardNumberElement);
      const cardExpiryElement = elements.getElement(CardExpiryElement);
      const cardCvcElement = elements.getElement(CardCvcElement);

      const { token: cardNumberToken } = await stripe.createToken(cardNumberElement);
      const { token: cardExpiryToken } = await stripe.createToken(cardExpiryElement);
      const { token: cardCvcToken } = await stripe.createToken(cardCvcElement);

      if (cardNumberToken && cardExpiryToken && cardCvcToken) {
        const data = isUpdate ? await update(cardNumberToken.id) : await register(cardNumberToken.id);
        if (data) {
          setIsSubmit(false);
        }
      } else {
        setErrMessage(
          t("DashBoardStripe.カード登録で、エラーが発生しました。正しく情報が入力されているか確認してください。"),
        );
        setIsSubmit(false);
      }
      setIsSubmit(false);
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    if (e.error) {
      setErrMessage(e.error.message);
    } else {
      setErrMessage("");
    }
    setIsComplete(e.complete);
  };

  return (
    <form onSubmit={handleSubmit} className="w-100" id="stripeForm">
      <div className="d-flex flex-row" style={{ gap: "16px" }}>
        <div className="d-flex flex-column" style={{ marginTop: "24px", gap: "16px", width: "100%" }}>
          <div className={style.secureForm}>
            <span>Secure form</span>
            <img src={getImageUrl("images/icons/lock.svg")} height="14" />
          </div>
          <div className="d-flex align-items-center" style={{ position: "relative" }}>
            <CardNumberElement
              id="card-number"
              onChange={handleChange}
              className={`${style.StripeInputField}`}
              options={{
                ...StripeFieldOptions,
                placeholder: "カード番号",
              }}
            />
            <div style={{ position: "absolute", right: "10px" }}>
              <img src={getImageUrl("images/icons/inputCardBrand.svg")} height="18" />
            </div>
          </div>
          <div className="d-flex justify-content-between" style={{ gap: "16px" }}>
            <CardExpiryElement
              id="card-expiry"
              onChange={handleChange}
              className={`${style.StripeInputField}`}
              options={{
                ...StripeFieldOptions,
                placeholder: "有効期限",
              }}
            />
            <CardCvcElement
              id="card-cvc"
              onChange={handleChange}
              className={`${style.StripeInputField}`}
              options={StripeFieldOptions}
            />
          </div>
        </div>
      </div>
      <span className="w-100 yoom-text-error test-card-submit-error" data-testid="error-message">
        {errMessage}
      </span>
    </form>
  );
};

Stripe.propTypes = {
  client: PropTypes.string,
  register: PropTypes.func,
  isUpdate: PropTypes.bool,
  update: PropTypes.func,
  setIsUpdate: PropTypes.func,
  updateAmountPlan: PropTypes.func,
  setIsLoading: PropTypes.func,
};

CreditInput.propTypes = {
  client: PropTypes.string,
  register: PropTypes.func,
  isUpdate: PropTypes.bool,
  update: PropTypes.func,
  setIsUpdate: PropTypes.func,
  updateAmountPlan: PropTypes.func,
  setIsLoading: PropTypes.func,
};
